// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { StatsRoutingModule } from './stats-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { ChartsModule, ThemeService } from 'ng2-charts';
import { StatsListComponent } from 'src/app/modules/stats/pages/stats-list/stats-list.page';
import { PropertiesInStructureListDialogComponent } from './components/properties-in-structure-list-dialog/properties-in-structure-list-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,
    ChartsModule,

    // Custom
    StatsRoutingModule,
    // PublicModule,
  ],
  declarations: [
    StatsListComponent,
    PropertiesInStructureListDialogComponent,
  ],
  entryComponents: [
    PropertiesInStructureListDialogComponent,
  ],
  providers: [
    ThemeService,
  ],
  exports: [
  ]
})
export class StatsModule { }
